export default {
  unsaved: {
    title: 'Änderungen speichern?',
    description: 'Du hast Änderungen an diesem Schritt vorgenommen, die noch nicht gespeichert wurden.',
    discard: 'Verwerfen',
    save_and_continue: 'Speichern und fortfahren',
  },
  title: 'Richte dein Restaurant ein',
  nav: {
    completed: 'Abgeschlossen',
    locked: 'Übernimmt dein Anbieter',
    aria_label: 'Launch-Schritte',
    step_label: 'Schritt {{number}}',
    section_label: 'Launch',
    back_to_home: 'Zurück zur Startseite',
  },
  owner_invite: {
    hint: 'Soll der Restaurantinhaber die Einrichtung selbst abschließen? Lade ihn ein – er macht dort weiter, wo du aufgehört hast.',
    sent: 'Einladung an {{name}} ({{email}}) am {{date}} gesendet.',
  },
  footer: {
    step_of: 'Schritt {{current}} von {{total}}',
  },
  buttons: {
    next_task: 'Nächste Aufgabe',
    cancel: 'Abbrechen',
    back: 'Zurück',
    next: 'Weiter',
    save: 'Speichern',
    exit: 'Einrichtung verlassen',
    retry: 'Erneut versuchen',
  },
  errors: {
    progress_load_failed: 'Der Einrichtungsfortschritt dieses Restaurants konnte nicht geladen werden.',
    linked_company_unavailable:
      'Dieser Link gehört zu einem Restaurant, das du nicht öffnen kannst – du bleibst bei deinem aktuellen.',
  },
  placeholder: {
    title: 'Dieser Schritt folgt in Kürze',
    description: 'Der Wizard-Rahmen und die Fortschrittsverfolgung sind fertig. Diese Phase wird als Nächstes gebaut.',
  },
  new_restaurant: {
    title: 'Neues Restaurant',
    menu: {
      title: 'Menü',
      description: 'Eine Demo überspringt das Onboarding — importiere daher jetzt ihr Menü.',
    },
    demo: {
      title: 'Neue Demo',
      description: 'Ein Demo-Restaurant zum Testen — es überspringt den größten Teil des Onboardings.',
      label: 'Demo erstellen',
    },
    description: 'Sag uns, wo dieses Restaurant ist. Wir suchen es auf Google Maps.',
  },
  location: {
    edit_description: 'Aktualisiere den Standort dieses Restaurants.',
    cta: 'Restaurant erstellen',
    section: {
      address: 'Basisinformationen',
      group: 'Marke',
      group_description: 'Gehört dieser Standort zu einer Marke, die du bereits hast?',
    },
    form: {
      name: {
        label: 'Restaurantname',
        placeholder: 'Nach deinem Restaurant suchen…',
        help: 'Tippe los, um dieses Restaurant auf Google Maps zu suchen.',
      },
      address: {
        label: 'Straße und Hausnummer',
        placeholder: 'Straße und Hausnummer',
      },
      city: {
        label: 'Stadt',
      },
      zip_code: {
        label: 'Postleitzahl',
      },
      country: {
        label: 'Land',
      },
      region: {
        label: 'Bundesland / Region',
        placeholder: 'Bundesland oder Region auswählen',
      },
    },
    group: {
      aria_label: 'Markenoptionen',
      deferred_hint: 'Markennamen und Web-Adresse legst du im letzten Schritt fest.',
      existing: {
        title: 'Zu einer bestehenden Marke hinzufügen',
        description: 'Ein weiterer Standort einer Marke, die du bereits führst.',
        select_label: 'Marke',
        select_placeholder: 'Marke auswählen',
      },
      new: {
        title: 'Neue Marke erstellen',
        description: 'Ein einzelnes Restaurant oder der erste Standort einer neuen Marke.',
      },
    },
    toasts: {
      update_failed: 'Der Standort konnte nicht gespeichert werden. Bitte versuche es erneut.',
      created: 'Restaurant erstellt',
      create_failed: 'Das Restaurant konnte nicht erstellt werden. Bitte erneut versuchen.',
    },
  },
  domain: {
    url_setup: {
      title: 'Adresse für Online-Bestellungen',
      description: 'Wo Gäste ihre Bestellungen aufgeben.',
    },
    modes: {
      foodamigos: {
        host_fallback: 'deiner Bestell-Domain',
        title: 'Unsere generische Domain verwenden',
      },
      custom: {
        title: 'Eigene Domain verbinden',
        description: 'Nutze eine Domain, die das Restaurant bereits besitzt.',
      },
    },
    toasts: {
      save_failed: 'Die Bestelladresse konnte nicht gespeichert werden. Bitte versuche es erneut.',
    },
  },
  go_live: {
    subtitle: 'Prüfe, ob alle Schritte erledigt sind, und schalte dann Live-Bestellungen frei.',
    slug: {
      help: 'Nur Buchstaben, Zahlen und Bindestriche. Du kannst dies später ändern, die alte Adresse funktioniert dann jedoch nicht mehr.',
      title: 'Adresse für Online-Bestellungen',
      description: 'Hier bestellen deine Kunden. Du kannst sie später ändern.',
      label: 'Mit dem Restaurantnamen anpassen',
      placeholder: 'bella-italia',
      preview: 'Deine Bestellseite:',
      save: 'URL speichern',
      saved: 'Bestelladresse gespeichert',
      save_failed: 'URL konnte nicht gespeichert werden. Bitte erneut versuchen.',
      status: {
        checking: 'Verfügbarkeit wird geprüft…',
        available: 'Verfügbar',
        taken: 'Diese URL ist bereits vergeben',
        invalid: 'Nur Buchstaben, Zahlen, Bindestriche und Unterstriche verwenden',
        error: 'Verfügbarkeit konnte nicht geprüft werden — bitte erneut versuchen',
      },
    },
    domain: {
      title: 'Eigene Domain (optional)',
      description: 'Verwende deine eigene Domain anstelle der von FoodAmigos bereitgestellten Adresse.',
      add: '+ Eigene Domain hinzufügen',
      hide: 'Eigene Domain ausblenden',
      label: 'Deine Domain',
      placeholder: 'shop.meinrestaurant.de',
      save: 'Speichern',
      show_records: 'DNS-Einträge anzeigen',
      hint: 'Nur für Bestellungen — deine Website braucht eine andere Domain. Zum Beispiel bestellen.meinrestaurant.de für den Shop und meinrestaurant.de für die Website.',
      records_after_save:
        'Sobald du die Domain speicherst, zeigen wir dir genau die Einträge, die du bei deinem DNS-Anbieter anlegen musst — eine Hauptdomain (meinrestaurant.de) und eine Subdomain (bestellen.meinrestaurant.de) brauchen unterschiedliche.',
      saved: 'Eigene Domain gespeichert',
      save_failed: 'Domain konnte nicht gespeichert werden. Bitte erneut versuchen.',
      unconfirmed: {
        title: 'Live gehen wartet nicht auf diese Domain',
        description:
          'Bis ihre Einträge bestätigt sind, bleibt die Bestellseite unter der Standardadresse, und das Restaurant kann dort live gehen. Sobald sie bestätigt sind — das kann bis zu 48 Stunden dauern —, zeigt die Domain die Bestellseite automatisch an.',
      },
    },
    locations: {
      title: 'Standorte bestätigen',
      description: 'Jeder Standort deiner Marke erhält eine eigene Bestelladresse. Bestätige oder bearbeite sie unten.',
      save: 'Standorte speichern',
      saved: 'Standort-URLs gespeichert',
      save_failed: 'Eine oder mehrere Standort-URLs konnten nicht gespeichert werden. Bitte erneut versuchen.',
    },
    preflight: {
      title: 'Bevor du live gehst',
      description: 'Schließe diese Punkte ab, um Live-Bestellungen freizuschalten.',
      url_setup: 'Bestelladresse eingerichtet',
      online_payment: {
        // Case-neutral: it follows both "wartet auf" and "bei".
        your_provider: 'Zahlungsanbieter',
        payments_live: '{{title}} · erledigt',
        online_payments_off: '{{title}} · keine Online-Zahlungen',
        waiting_for_provider: '{{title}} · wartet auf {{provider}}',
        hosted_not_finished: '{{title}} · bei {{provider}} abschließen',
        action_needed: '{{title}} · Handlung erforderlich',
        waiting_for_partner: '{{title}} · wartet auf deinen Partner',
        not_set_up: '{{title}} · nicht eingerichtet',
        business_details_missing: '{{title}} · Unternehmensangaben für Auszahlungen hinzufügen',
      },
    },
    failed_checks: {
      title: 'Ein paar Dinge fehlen noch',
      items: {
        name: 'Restaurantname',
        logo_url: 'Logo',
        pictures: 'Galeriefotos',
        menu_uploaded: 'Speisekarte',
        opening_hours: 'Öffnungszeiten',
        address: 'Adresse',
        storefront: 'Bestelladresse',
        payments_configured: 'Zahlungen',
        stripe_billing: 'Abrechnung',
        test_orders: 'Testbestellung',
        google_business: 'Google-Unternehmensprofil',
        master_promo_code: 'Willkommens-Gutscheincode',
        flyers_ordered: 'Flyer bestellt',
        identity: 'Restauranttyp & Küchen',
        billing_payment_method: 'Zahlungsmethode',
        billing_license: 'Lizenz',
        business_name: 'Unternehmens- / Restaurantname',
        payment_method: 'Bar- oder Online-Zahlungen',
        stripe_processing_fee: 'Verarbeitungsgebühr des Partners',
      },
      force: 'Trotzdem live gehen',
      blocker: '(erforderlich)',
      link: 'Partnerabrechnung öffnen',
    },
    error: 'Live-Bestellungen konnten nicht aktiviert werden. Bitte erneut versuchen.',
    gate_hint: 'Schließe die Checkliste oben ab, um „Live gehen“ freizuschalten.',
    business_name: {
      label: 'Unternehmens- / Restaurantname',
      help: 'Erscheint in deinen Nutzungsbedingungen und deiner Datenschutzerklärung. Verwende den Namen, unter dem dein Unternehmen auftritt.',
      save: 'Speichern',
      save_failed: 'Der Unternehmensname konnte nicht gespeichert werden. Bitte erneut versuchen.',
      hint: 'Speichere zuerst den Unternehmens- / Restaurantnamen.',
    },
    cash_only: {
      message:
        'Online-Zahlungen sind aus — Kunden können nur bar bei Abholung oder Lieferung zahlen, bis ein Zahlungsanbieter verbunden und verifiziert ist.',
    },
    payment_blocked: {
      title: 'Schalte Barzahlung ein oder richte Online-Zahlungen ein, um live zu gehen.',
      payment_method: 'Kunden brauchen eine Möglichkeit zu zahlen.',
      turn_on_cash: 'Barzahlung einschalten',
      ask_partner: 'Bitte deinen Partner, Barzahlung einzuschalten, oder',
      set_up_online: 'Online-Zahlungen einrichten',
    },
    buttons: {
      go_live: 'Live gehen 🚀',
      finish: 'Einrichtung abschließen',
    },
    celebration: {
      title: 'Du bist live!',
      title_named: '{{name}} ist live!',
      subtitle: 'Dein Restaurant nimmt jetzt Live-Bestellungen an.',
      license: '{{plan}} · aktiv',
      license_trial: '{{plan}} · kostenlos bis {{date}}',
      finish: 'Einrichtung abschließen',
    },
    service_fee: {
      title: 'Servicegebühr',
      headline: 'Zusätzlicher Umsatz, ohne deine Restaurants zu belasten',
      subtitle:
        'Füge eine kleine Servicegebühr hinzu, die Gäste an der Kasse zahlen. Die Hälfte gehört dir. Sie bleibt aus, solange du sie nicht einschaltest.',
      subtitle_share:
        'Füge eine kleine Servicegebühr hinzu, die Gäste an der Kasse zahlen. {{share}} % gehören dir. Sie bleibt aus, solange du sie nicht einschaltest.',
      tiles: {
        guest: {
          title: 'Vom Gast bezahlt',
          description: 'An der Kasse ausgewiesen, wie bei Liefer-Apps.',
        },
        share: {
          title: 'Die Hälfte geht an dich',
          title_share: '{{share}} % gehen an dich',
          description: '{{share}}/{{rest}} geteilt mit FoodAmigos.',
        },
        choice: {
          title: 'Deine Entscheidung',
          description: 'Standardmäßig aus. Jederzeit änderbar.',
        },
      },
      preview: {
        title: 'Was Gäste an der Kasse sehen würden',
        subtotal: 'Zwischensumme',
        fee: 'Servicegebühr',
        fee_terms: '({{percentage}} %, max. {{max}})',
        guest_pays: 'Gast zahlt',
        split_partner: '<strong>Du {{amount}}</strong> pro Bestellung',
        split_provider: 'FoodAmigos {{amount}}',
        unchanged: 'Der Bestellwert des Restaurants bleibt unverändert.',
      },
      earnings: {
        title: 'Was du mit diesem Restaurant verdienen könntest',
        orders: 'Online-Bestellungen pro Monat',
        average_order: 'Durchschnittliche Bestellung',
        per_month: 'pro Monat für dich',
        collected: '{{amount}} pro Monat von Gästen eingenommen. Dein Anteil: {{share}} %. Nur eine Schätzung.',
        effective_rate: 'Effektiver Gebührensatz über alle Bestellungen: {{rate}}',
      },
      choice: {
        question: 'Servicegebühr für dieses Restaurant hinzufügen?',
        enabled: {
          title: 'Servicegebühr hinzufügen',
          recommended: 'Empfohlen: {{percentage}} %, max. {{max}}',
          description: 'Gäste zahlen eine kleine Gebühr. Du verdienst einen Anteil.',
        },
        skipped: {
          title: 'Keine Servicegebühr',
          description: 'Gäste zahlen nur die Menüpreise.',
        },
      },
      footer: {
        enabled:
          'Gäste zahlen {{percentage}} %, max. {{max}} pro Bestellung. Jederzeit änderbar unter <settings>Bestell Einstellungen → Servicegebühr</settings>.',
        skipped:
          'Vorerst keine Servicegebühr. Jederzeit änderbar unter <settings>Bestell Einstellungen → Servicegebühr</settings>.',
      },
      enabled:
        'Die Servicegebühr ist für dieses Restaurant jetzt aktiv: {{percentage}} %, maximal {{max}} pro Bestellung. Sie gilt ab sofort für alle neuen Bestellungen. Jederzeit änderbar unter <settings>Bestell Einstellungen → Servicegebühr</settings>.',
      enabled_partner_default:
        'Die Servicegebühr ist für dieses Restaurant jetzt aktiv. Es gilt dein Partner-Standard: {{percentage}} %, maximal {{max}} pro Bestellung. Sie gilt ab sofort für alle neuen Bestellungen. Jederzeit änderbar unter <settings>Bestell Einstellungen → Servicegebühr</settings>.',
      buttons: {
        enable: 'Servicegebühr aktivieren',
        continue_without: 'Ohne Gebühr fortfahren',
      },
      skipped:
        'Gäste in diesem Restaurant zahlen keine Servicegebühr. Du kannst sie jederzeit unter <settings>Bestell Einstellungen → Servicegebühr</settings> aktivieren.',
      toasts: {
        save_failed: 'Die Auswahl zur Servicegebühr konnte nicht gespeichert werden. Bitte versuche es erneut.',
      },
    },
  },
  toasts: {
    save_failed: 'Änderungen konnten nicht gespeichert werden. Bitte versuche es erneut.',
    saved: 'Gespeichert',
  },
  optional: 'Optional',
  identity: {
    min_cuisine_hint: 'Wähle mindestens eine Küche aus, um fortzufahren.',
    sections: {
      restaurant_type: {
        title: 'Restauranttyp',
        description: 'Um welche Art von Betrieb handelt es sich?',
      },
      cuisine: {
        title: 'Küchenarten',
        description: 'Wähle mindestens eine aus.',
      },
    },
  },
  menu: {
    modes: {
      recommended: 'Empfohlen',
      import: {
        title: 'Von einer Plattform importieren',
        description: 'Übernimm das Menü von Wolt, Lieferando, Deliveroo und mehr.',
      },
      manual: {
        title: 'Menü von Grund auf erstellen',
        description: 'Erstelle Kategorien und Artikel manuell im Menü-Editor.',
      },
    },
    import: {
      title: 'Von bestehender Plattform importieren',
      in_progress: {
        title: 'Menü wird importiert…',
        description:
          'Das dauert normalerweise unter zwei Minuten. Wir schließen diesen Schritt ab, sobald der Import fertig ist.',
      },
      failed: {
        title: 'Der Import wurde nicht abgeschlossen',
        description:
          'Der Menü-Import konnte nicht abgeschlossen werden. Bitte prüfe die Angaben und versuche es erneut.',
      },
      blocked: {
        until: 'Pausiert bis {{time}}',
        release: 'Link freigeben',
        released: 'Link freigegeben. Du kannst den Import jetzt erneut starten.',
        release_failed: 'Der Link konnte nicht freigegeben werden. Bitte versuche es gleich noch einmal.',
      },
      stalled: {
        title: 'Import läuft noch…',
        description:
          'Der Import dauert länger als üblich. Er läuft möglicherweise noch im Hintergrund — prüfe es in einem Moment erneut. Ein neuer Import jetzt könnte die Speisekarte doppelt anlegen.',
      },
    },
    manual: {
      title: 'Menü von Grund auf erstellen',
      description:
        'Der Menü-Editor öffnet sich mit einem leeren Menü. Dieser Schritt ist abgeschlossen, sobald mindestens eine Kategorie und ein Artikel vorhanden sind.',
      open_editor: 'Menü-Editor öffnen',
      waiting: {
        title: 'Warten auf deinen ersten Menü-Artikel',
        description: 'Sobald du im Menü-Editor einen Artikel hinzufügst, kann dieser Schritt abgeschlossen werden.',
      },
      found: {
        title: 'Menü-Artikel erkannt',
        description: 'Super — du kannst zum nächsten Schritt weitergehen.',
      },
    },
    complete: {
      title: 'Menü bereit',
      description: 'Dein Menü ist eingerichtet. Du kannst es jederzeit im Menü-Editor überprüfen.',
    },
    buttons: {
      start_import: 'Import starten',
      importing: 'Wird importiert…',
      retry: 'Import erneut versuchen',
      check_again: 'Erneut prüfen',
      continue: 'Weiter',
      skip: 'Vorerst überspringen',
    },
  },
  phases: {
    // Platzhalter für den Restaurantnamen, solange dieser noch nicht bekannt ist.
    fallback_name: 'dieses Restaurant',
    location: {
      title: 'Standort',
      description: 'Wo befindet sich das Restaurant und zu welcher Marke gehört es?',
    },
    identity: {
      title: 'Identität',
      description: 'Restauranttyp und Küchen.',
    },
    brand: {
      title: 'Marke',
      description: 'Logo, Farben und Galerie.',
    },
    operations: {
      title: 'Standortdetails',
      description:
        'Lege fest, wie {{name}} Bestellungen annimmt. Das ist die Mindestanforderung, bevor Bestellungen eingehen können.',
    },
    menu: {
      title: 'Menü',
      description:
        'Bring das Menü von {{name}} auf die Plattform. Importiere es in unter zwei Minuten von einer bestehenden Plattform oder erstelle es von Grund auf.',
    },
    domain: {
      title: 'Domain',
      description: 'Die Web-Adresse, über die Kunden bei diesem Restaurant bestellen.',
    },
    go_live: {
      title: 'Live gehen',
      description: 'Live-Bestellungen aktivieren.',
    },
    payouts: {
      title: 'Online-Zahlung',
      description: 'Wie dieses Restaurant online Zahlungen entgegennimmt.',
    },
    service_fee: {
      title: 'Servicegebühr',
      description:
        'Ob Gäste beim Bezahlen eine Servicegebühr zahlen. Sie können das später unter Bestelleinstellungen → Gebühren ändern.',
    },
    bank_account: {
      title: 'Bankkonto',
      description:
        'Wohin Auszahlungen gehen. Für das Live-Gehen nicht nötig: Zahlungen bleiben im Guthaben, bis ein Konto hinterlegt ist.',
    },
  },
  business_details: {
    locked:
      'Diese Angaben sind bei Ihrem Zahlungsanbieter verifiziert. Wenden Sie sich an FoodAmigos, um sie zu ändern.',
    section: {
      title: 'Unternehmensangaben',
    },
    fields: {
      business_type: {
        label: 'Unternehmensform',
        options: {
          company: 'Unternehmen (GmbH, UG, Ltd, Inc — eine eingetragene juristische Person)',
          individual: 'Einzelperson (Sie führen das Geschäft persönlich)',
        },
      },
      owner_first_name: { label: 'Vorname der Inhaberin/des Inhabers' },
      owner_last_name: { label: 'Nachname der Inhaberin/des Inhabers' },
      legal_name: {
        label: 'Offizieller Firmenname',
        individual:
          'Sie führen das Geschäft persönlich, daher wird der Name der Inhaberin/des Inhabers als offizieller Firmenname verwendet.',
      },
      legal_address: { label: 'Eingetragene Adresse' },
      legal_city: { label: 'Stadt' },
      legal_state: { label: 'Bundesland oder Provinz' },
      legal_zip_code: { label: 'Postleitzahl' },
      legal_country: { label: 'Land' },
      tax_id: {
        generic: 'Steuer- oder Registernummer',
        personal:
          'Es werden nur die letzten vier Ziffern angezeigt. Lassen Sie das Feld unverändert, um die Nummer beizubehalten.',
        hint: 'Zum Beispiel {{example}}.',
        invalid:
          'Das entspricht nicht dem üblichen Format für dieses Land und diese Unternehmensform, zum Beispiel {{example}}.',
      },
      is_vat_registered: { label: 'Dieses Unternehmen ist umsatzsteuerpflichtig' },
      vat_id: {
        label: 'USt-IdNr.',
        help: 'Beginnt mit {{country}}, gefolgt von 8 bis 12 Buchstaben oder Ziffern.',
        invalid: 'Die USt-IdNr. muss mit {{country}} beginnen, gefolgt von 8 bis 12 Buchstaben oder Ziffern.',
        help_unprefixed: 'Ihre Umsatzsteuer- bzw. Steuerregistrierungsnummer, wie erteilt.',
        invalid_unprefixed: 'Das sieht nicht nach einer USt-IdNr. aus: 5 bis 25 Buchstaben oder Ziffern.',
      },
    },
    toasts: {
      save_failed: 'Ihre Unternehmensangaben konnten nicht gespeichert werden. Bitte versuchen Sie es erneut.',
    },
  },
  brand: {
    fields: {
      short_name: {
        label: 'Kurzname',
        placeholder: 'z. B. Amigo Pizza',
        tooltip: 'Ein kürzerer Anzeigename, der im Storefront und auf Belegen verwendet wird.',
      },
      primary_color: {
        label: 'Primärfarbe',
        invalid: 'Gib eine gültige Hex-Farbe ein, z. B. #1A73E8.',
      },
    },
    sections: {
      short_name: 'Name',
      short_name_hint: 'Wird im Shop, auf Belegen und in Benachrichtigungen verwendet.',
      logo_and_colour: 'Logo & primäre Markenfarbe',
      logo: 'Logo hochladen',
      logo_hint: 'Bleibt dies leer, wird das Logo der Marke verwendet.',
      gallery: 'Galeriefotos',
      gallery_hint: 'Füge bis zu {{max}} Fotos deines Restaurants hinzu. Zum Sortieren ziehen.',
      gallery_count: '{{count}} von {{max}} hinzugefügt',
    },
    toasts: {
      image_uploaded: 'Bild hochgeladen',
      image_upload_failed: 'Das Bild konnte nicht hochgeladen werden. {{error}}',
      save_failed: 'Deine Markendaten konnten nicht gespeichert werden. Bitte versuche es erneut.',
    },
  },
  operations: {
    contact: {
      title: 'Kontakt',
      description: 'Wird für Bestellbenachrichtigungen und die Kundenkommunikation verwendet.',
      phone: {
        label: 'Telefonnummer des Restaurants',
        placeholder: '+49 30 1234567',
        invalid: 'Gib eine vollständige internationale Telefonnummer ein, z. B. +49 30 1234567',
      },
      email: { label: 'E-Mail des Restaurants', placeholder: 'bestellungen@restaurant.de' },
    },
    methods: {
      title: 'Bestellmethoden',
      description: 'Wie Kunden bestellen können und wie lange jede Methode dauert.',
      pickup: {
        label: 'Abholung',
        prep_time: { label: 'Durchschnittliche Zubereitungszeit (Min.)' },
      },
      delivery: {
        label: 'Lieferung',
        delivery_time: { label: 'Durchschnittliche Lieferzeit (Min.)' },
        advanced_zones: 'Erweiterte Zoneneinrichtung',
      },
    },
    timing: {
      title: 'Bestellzeitpunkt',
      description: 'Wann Kunden bestellen können — sofort, später oder im Voraus.',
      at_least_one: 'Aktiviere Sofort- oder Vorbestellungen (mindestens eines ist erforderlich).',
      asap: { label: 'Sofortbestellungen annehmen' },
      scheduled: { label: 'Geplante Bestellungen annehmen' },
      reminders: { label: 'Automatische Erinnerung senden, bevor eine geplante Bestellung fällig ist' },
      pre_order: {
        label: 'Vorbestellungen für spätere Tage erlauben',
        days: { label: 'Wie viele Tage im Voraus (0-31)' },
      },
    },
    tax: {
      title: 'Umsatzsteuer',
      description:
        'Der Satz für die Produkte dieses Restaurants. Voreingestellt ist der Satz der Region — ändern Sie ihn nur, wenn für dieses Restaurant ein anderer gilt.',
      rate: { label: 'Umsatzsteuersatz', placeholder: 'z. B. 7' },
      dedicated: { label: 'Umsatzsteuer unterscheidet sich je Produkt' },
    },
    hours: {
      title: 'Öffnungszeiten',
      description: 'Die Tage und Zeiten, an denen dieses Restaurant Bestellungen annimmt.',
      same_every_day: 'Jeden Tag gleiche Zeiten',
      split_shifts: {
        title: 'Dieses Restaurant hat geteilte Öffnungszeiten',
        description:
          'An manchen Tagen gibt es mehr als einen Öffnungszeitraum (z. B. eine Mittags- und eine Abendschicht). Der einfache Editor hier zeigt einen Zeitraum pro Tag, daher lassen wir deine bestehenden Zeiten unverändert — bearbeite geteilte Schichten unter Bestell­einstellungen → Öffnungszeiten.',
      },
    },
    toasts: {
      save_failed: 'Die Betriebseinstellungen konnten nicht gespeichert werden. Bitte erneut versuchen.',
    },
  },
  online_payment: {
    question: 'Möchtest du für dieses Restaurant Online-Zahlungen annehmen?',
    yes: 'Ja',
    not_now: 'Jetzt nicht',
    declined:
      'Kunden bezahlen bei Abholung oder Lieferung. Du kannst Online-Zahlungen jederzeit in den Einstellungen aktivieren.',
    providers: {
      stripe: 'Stripe',
      adyen: 'Adyen',
    },
    waiting_for_partner: {
      staff: {
        title: 'Für dein Partnerkonto sind die Zahlungen noch nicht eingerichtet',
        description:
          'Ein Admin deines Partnerkontos muss festlegen, wer die Zahlungen abwickelt, bevor dieses Restaurant Online-Zahlungen annehmen kann. Mit den anderen Schritten kannst du in der Zwischenzeit weitermachen.',
      },
    },
    continue_to_go_live: 'Weiter zum Go-Live',
    platform_line: 'Zahlungen für dieses Restaurant laufen über FoodAmigos Payments.',
    only_connection: 'Zahlungen laufen über {{name}} (dein einziger verbundener Anbieter).',
    partner_issue: {
      title: 'Dein Partner {{partner}} muss die Einrichtung seines Zahlungsanbieters noch abschließen',
      description:
        'Sein Zahlungsanbieter kann noch keine Restaurants anbinden. Wir haben ihn informiert. Deine Angaben sind gespeichert, schau wieder vorbei, sobald er die Einrichtung bestätigt hat.',
      retry_hint: 'Sobald das behoben ist, geh erneut zum Anbieter weiter – wir versuchen es dann noch einmal.',
      open_settings: 'Einstellungen zum Zahlungsanbieter öffnen',
    },
    connect_another: 'Weiteren Anbieter verbinden',
    checking: 'Wir prüfen den Stand bei {{provider}}…',
    checking_generic: 'Wir prüfen den Stand beim Zahlungsanbieter…',
    retry: 'Erneut versuchen',
    not_set_up: {
      title: 'Noch kein Zahlungsanbieter verknüpft',
      description:
        'Dein Partner verknüpft einen Zahlungsanbieter mit diesem Restaurant. Sobald das passiert ist, kannst du die Einrichtung hier abschließen.',
    },
    choice: {
      title: 'Welchen deiner verbundenen Anbieter soll dieses Restaurant nutzen?',
      primary: 'Standard',
      confirm: 'Diesen Anbieter nutzen',
      cancel: 'Abbrechen',
    },
    using: 'Genutzt wird {{name}}',
    change: 'Ändern',
    payout_details: {
      title: 'Unternehmensangaben für Auszahlungen',
      description: 'Der Zahlungsanbieter benötigt sie, um Ihr Unternehmen zu verifizieren und Auszahlungen zu senden.',
      business_type: {
        company: {
          title: 'Unternehmen',
          description: 'GmbH, UG, Ltd, Inc — eine eingetragene juristische Person',
        },
        individual: {
          title: 'Einzelperson',
          description: 'Sie führen das Geschäft persönlich',
        },
      },
      registered_address: 'Eingetragene Adresse',
      legal_address: 'Straße und Hausnummer',
      legal_state: 'Bundesland / Region',
      vat_id: 'USt-IdNr.',
      optional: '(optional)',
      fill_first: 'Füllen Sie zuerst die Unternehmensangaben für Auszahlungen oben aus.',
    },
    hand_off: {
      title: 'Als Nächstes: Einrichtung bei {{provider}} abschließen',
      description:
        '{{provider}} fragt in einem eigenen Formular nach dem Ausweisdokument des Inhabers und nutzt dafür die Geschäftsdaten für Auszahlungen von oben. Das dauert etwa 10 Minuten. Das Bankkonto folgt nach dem Live-Gehen.',
      cta: 'Weiter zu {{provider}}',
      transition: 'Wir leiten dich zu {{provider}} weiter…',
      error: 'Das Formular von {{provider}} konnte nicht geöffnet werden. Bitte versuch es erneut.',
    },
    states: {
      verified: 'Zahlungen sind live.',
      submitted: {
        title: 'Daten an {{provider}} gesendet',
        description:
          'Die Prüfung dauert in der Regel 1–2 Werktage. Wir schicken dem Restaurantinhaber eine E-Mail, sobald sie abgeschlossen ist.',
        description_email:
          'Die Prüfung dauert in der Regel 1–2 Werktage. Wir schreiben an {{email}}, sobald sie abgeschlossen ist.',
        review: {
          business_type: 'Unternehmensform',
          legal_name: 'Rechtlicher Name',
          address: 'Eingetragene Adresse',
          types: {
            company: 'Unternehmen',
            individual: 'Einzelperson',
          },
        },
      },
      incomplete: {
        title: 'Du hast die Einrichtung bei {{provider}} noch nicht abgeschlossen',
        description: 'Deine Daten sind gespeichert — der Link ist 2 Tage gültig.',
        expired: 'Deine Daten sind gespeichert, aber der Link ist abgelaufen.',
        cta: 'Weiter bei {{provider}}',
        new_link: 'Neuen Link holen und weitermachen',
        check_details: 'Erst meine Daten prüfen',
      },
      action_needed: {
        title: '{{provider}} braucht noch eine Angabe',
        description:
          '{{provider}} konnte eine deiner Angaben nicht bestätigen. Öffne das Formular erneut, um sie zu korrigieren.',
        cta: 'Formular von {{provider}} erneut öffnen',
      },
    },
    connected: {
      title: 'Zahlungen laufen über {{name}}',
      description: 'Dieses Restaurant ist mit dem {{name}}-Konto verknüpft — hier ist nichts weiter einzurichten.',
      failed: 'Dieses Restaurant konnte noch nicht mit {{name}} verknüpft werden',
    },
    errors: {
      generic: 'Etwas ist schiefgelaufen. Bitte versuch es erneut.',
      load_failed: 'Die Zahlungseinrichtung dieses Restaurants konnte nicht geladen werden.',
    },
  },
  bank_account: {
    section: {
      title: 'Bankkonto für Auszahlungen',
      description: 'Auszahlungen erfolgen in {{currency}}, der Währung, in der dieses Restaurant Zahlungen annimmt.',
    },
    done: 'Zurück zum Dashboard',
    load_failed: 'Das Bankkonto dieses Restaurants konnte nicht geladen werden.',
    retry: 'Erneut versuchen',
    no_permission: 'Nur der Inhaber des Restaurants oder der Partner kann das Bankkonto hinterlegen.',
    confirm_with_provider: 'Bei Adyen bestätigen',
    toasts: {
      save_failed: 'Das Bankkonto konnte nicht gespeichert werden. Bitte prüfen Sie die Angaben.',
    },
  },
  payouts: {
    finish_setup: 'Einrichtung abschließen',
  },
};
